import React from "react";
import { summariseCondition } from "./workflow-condition-labels";

/**
 * XPEN-3756: the workflow-level precondition, shown under the trigger. Same
 * shape as a branch precondition badge; with none set, a button to add one.
 */
const WorkflowPreconditionCard = ({ precondition, data, onClick }) => {
    const conditions = precondition?.conditions || [];
    const logic = precondition?.condition_logic || "all";

    return (
        <div className="d-flex justify-content-center">
            <div className="card shadow-sm mb-2 txt btn-light" style={{ width: "300px" }}>
                <div className="p-2" type="button" data-testid="workflow-precondition" onClick={onClick}>
                    <h6 className="mb-1 text-muted small">{data.t.read("rule.workflow_precondition")}</h6>
                    {conditions.length > 0 && (
                        <>
                            <div className="small text-muted mb-1">
                                {logic === "any" ? data.t.read("rule.if_any_match") : data.t.read("rule.if_all_match")}
                            </div>
                            <ul className="mb-0 small">
                                {conditions.map((c, index) => (
                                    <li key={c.id ?? index} className="p-1 border-radius-30">
                                        {summariseCondition(c, data.t)}
                                    </li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkflowPreconditionCard;
